/* eslint-disable */
import Vue from 'vue'
import i18n from '@/i18n'
import Axios from 'axios'

Axios.defaults.headers.post['Content-Type'] = 'application/json';
Axios.defaults.headers.put['Content-Type'] = 'application/json';
Axios.defaults.headers.delete['Content-Type'] = 'application/json';
Axios.defaults.headers.get['Content-Type'] = 'application/json';

const vue = new Vue({ i18n })
Axios.interceptors.response.use(
    (response) => response, 
    (err) => {
        return new Promise(function (resolve, reject) {
            let result = {
                success: false,
                config: {
                    url: err.config.url, 
                    headers: err.config.headers,
                },
                error: []                        
            };

            if(err.response != null && err.response != undefined){
                switch(err.response.status){
                    case 400: 
                        if(err.response.data.success == undefined){
                            result.error.push({ 
                                code: err.response.status,
                                type: "ResponseError",
                                userMessage: "Ocorreram um ou mais erros de validação",
                                userTitle: vue.$t("Common.response-error")
                            });

                            console.error(err.response.data)
                            reject(result); 
                        }
                        else{
                            reject(err.response.data); 
                        }

                        break; 

                    case 404: 
                        result.error.push({ 
                            code: err.response.status,
                            type: "ResponseError",
                            userMessage: vue.$t("Common.page-not-found"),
                            userTitle: vue.$t("Common.response-error")
                        });

                        reject(result);
                        break;                         

                    case 401: 
                    case 403: 
                        result.error.push({ 
                            code: err.response.status,
                            type: "ResponseError",
                            userMessage: vue.$t("Common.access-denied"),
                            userTitle: vue.$t("Common.response-error")
                        });

                        reject(result);
                        break;  
                        
                    case 500:
                        result.error.push({ 
                            code: err.response.status,
                            type: "ResponseError",
                            userMessage: err.response.statusText,
                            userTitle: vue.$t("Common.response-error")
                        });                         

                        if(err.response.data && !err.response.data.success){
                            reject(err.response.data);
                        }
                        else {
                            reject(result);
                        }
                         
                        break;    
                        
                    default:
                        result.error.push({ 
                            code: err.response.status,
                            type: "ResponseError",
                            userMessage: err.response.statusText,
                            userTitle: vue.$t("Common.response-error")
                        });     

                        reject(result);
                        break;                           
                }
            }
            else{       
                result.error.push({ 
                    code: 0,
                    type: "ResponseError",
                    userMessage: vue.$t("Common.communication-error"),
                    userTitle: vue.$t("Common.response-error"),
                });     
                
                reject(result);        
            }
        }
    );
});   

Vue.prototype.$http = Axios;

Vue.prototype.$httpJson = {
    async defineHeaderAxios () {
        Axios.defaults.headers.common["Authorization"] = "Bearer " + await Vue.prototype.$security.getAccessToken().catch(err => console.error("Token", err));
    },
    async get(url){
        await this.defineHeaderAxios();
        return new Promise(function(resolve, reject){
            Axios.get(url).then(
                (response) => resolve(response.data),
                (error) => reject(error)                      
            );
        });
    },
    async post(url, data){
        await this.defineHeaderAxios();

        return new Promise(function(resolve, reject){
            Axios.post(url, JSON.stringify(data)).then(
                (response) => resolve(response.data),
                (error) => reject(error)      
            );
        });
    },        
    async put(url, data){
        await this.defineHeaderAxios();

        return new Promise(function(resolve, reject){
            Axios.put(url, JSON.stringify(data)).then(
                (response) => resolve(response.data),
                (error) => reject(error)      
            );
        });
    },            
    async delete(url){
        await this.defineHeaderAxios();

        return new Promise(function(resolve, reject){
            Axios.delete(url).then(
                (response) => resolve(response.data),
                (error) => reject(error)      
            );
        });
    }, 
}
